export const host = "https://hommies-chat.vercel.app";
// https://hommies-chat-app-backend.herokuapp.com

export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;
export const getAllUsersRoute = `${host}/api/auth/getAllUsers`;
export const sendMessageRoute = `${host}/api/message/sendMessage`;
export const getAllMessagesRoute = `${host}/api/message/getAllMessages`;
export const clearChatMessagesRoute = `${host}/api/message/deleteAllMessages`;